/**
 * Module dependencies.
 */

import { closeNotify, openNotify } from 'reducers/notify/actions';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { makeSelectIsNotifyOpen, makeSelectNotifyOptions } from 'reducers/notify/selectors';

/**
 * Map state to props.
 */

const mapStateToProps = createStructuredSelector({
  isNotifyOpen: makeSelectIsNotifyOpen(),
  notifyOptions: makeSelectNotifyOptions(),
});

/**
 * Map dispatch to props.
 */

const mapDispatchToProps = (dispatch) => ({
  closeNotify: () => dispatch(closeNotify()),
  openNotify: (payload) => dispatch(openNotify(payload)),
});

/**
 * Export withNotify HOC.
 */

export default connect(mapStateToProps, mapDispatchToProps);
